import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestPluginUpdateSkipPost = {
    path: "/plugin-update/:slug/skip",
    method: RouteHttpVerb.POST
};
